import React from 'react';
import type { InvestmentQuickLink } from '@app-types/investmentIndicators';
import { postSectionJumpMessage } from '@utils/widgetMessages';
import './InvestmentQuickLinksRow.less';

export interface InvestmentQuickLinksRowProps {
  links: InvestmentQuickLink[];
  nodeId?: string;
}

/**
 * Jump links row below the widget nav.
 * Matches Performance Trends quick links: red, bold, underlined anchors.
 * Figma: desktop 3164:13454, mobile 3164:15710.
 */
const InvestmentQuickLinksRow: React.FC<InvestmentQuickLinksRowProps> = ({
  links,
  nodeId,
}) => (
  <nav
    className="investment-quick-links"
    aria-label="クイックリンク"
    data-node-id={nodeId}
  >
    {links.map((link) => (
      <a
        key={link.key}
        href={link.href}
        className="investment-quick-links__link"
        data-node-id={link.nodeId}
        onClick={(event) => {
          if (
            event.defaultPrevented || event.button !== 0 ||
            event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
            !link.href.startsWith('#')
          ) return;

          if (postSectionJumpMessage(link.href.slice(1), 6)) event.preventDefault();
        }}
      >
        {link.label}
      </a>
    ))}
  </nav>
);

export default InvestmentQuickLinksRow;
